import React from "react";
import "./CustoEconomia.css";

interface CustoEconomiaProps {
  totalCativo: number;
  totalLivre: number;
  economy: number;
  description: string;
}

const formatCurrency = (value: number) =>
  value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

function CustoEconomia({
  totalCativo,
  totalLivre,
  economy,
  description,
}: CustoEconomiaProps) {
  const economyPercentage =
    Math.abs(totalCativo) > 0 ? economy / totalCativo : 0;

  return (
    <section className="financial-summary">
      <div className="financial-summary__header">
        <h1>Resumo financeiro</h1>
        <p>{description}</p>
      </div>
      <div className="financial-summary__cards">
        <div className="financial-summary__card">
          <h2>Custo cativo</h2>
          <strong>{formatCurrency(totalCativo)}</strong>
        </div>
        <div className="financial-summary__card">
          <h2>Custo livre</h2>
          <strong>{formatCurrency(totalLivre)}</strong>
        </div>
        <div className="financial-summary__card">
          <h2>Economia</h2>
          <div>
            <strong>{formatCurrency(economy)}</strong>
            <span
              className={
                economy >= 0 ? "economia-positivo" : "economia-negativo"
              }
            >
              {Math.abs(economyPercentage).toLocaleString("pt-BR", {
                style: "percent",
              })}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CustoEconomia;
